import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocatorDisplay from "@store/Library/Components/LocatorDisplay";
import React, { FC } from "react";

const enum fields {
    context = "context",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.context]: string;
    };
}

const Locator: FC<OwnProps> = ({ fields }) => {
    return <LocatorDisplay context={fields.context} />;
};

const widgetModule: WidgetModule = {
    component: Locator,
    definition: {
        displayName: "Locator",
        icon: "house",
        group: "Common",
        allowedContexts: ["ProductDetailsPage", "Header"],
        fieldDefinitions: [
            {
                name: fields.context,
                fieldType: "General",
                editorTemplate: "RadioButtonsField",
                defaultValue: "widget",
                isRequired: true,
                options: [
                    {
                        displayName: "Page Widget",
                        value: "widget",
                    },
                    {
                        displayName: "Header Popup",
                        value: "header",
                    },
                    {
                        displayName: "Mobile Header Popup",
                        value: "mobile",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
